/**
 * Clone and reposition elements
 *
 * @param {}
 * @return {void}
 */


const repositionElements = () => {
	$('[data-prepend]').each(function(){
		const $this = $(this);
		const $clone = $this.clone().addClass('is-cloned');
		const newPosition = $this.data('prepend');

		$(newPosition).prepend($clone);
    $this.addClass('has-clone');
	});

	$('[data-append]').each(function(){
		const $this = $(this);
		const $clone = $this.clone().addClass('is-cloned');
		const newPosition = $this.data('append');

		$(newPosition).append($clone);
    $this.addClass('has-clone');
	});
}

repositionElements();
